// DEVELOPMENT DATA SERVICE

import axios from 'axios'
import '../plugins/axios'

const olsUserId = 7  //single abstract=36, bulk abstract=10, stp=11, renew reg=12, 45, 32, scale an 13

export default class UserService {

    public async getUser() {
        return await axios.get("olsUserProfile/getUserDefaultClient/" + olsUserId + "/0/true")
            .then( response => {
                return response.data;
            })
            .catch(error => console.log(error));
    }
}

export const userService = new UserService();
